import { jsx, jsxs } from "react/jsx-runtime";
import { connect } from "react-redux";
import React from "react";
import { DialogFooter, InfoHelper, wrapDialog } from "@teselagen/ui";
import { cutSequenceByRestrictionEnzyme } from "@teselagen/sequence-utils";
import {
  defaultEnzymesByName,
  getReverseComplementSequenceString
} from "@teselagen/sequence-utils";
import EnzymeViewer from "../EnzymeViewer";
import "./style.css";
import { connectToEditor } from "../withEditorProps";
import { compose } from "recompose";
import { Callout } from "@blueprintjs/core";
import { addCustomEnzyme } from "../utils/editorUtils";
const CreateCustomEnzyme = function(props) {
  const paddingStart = "-------";
  const paddingEnd = "-------";
  const {
    inputSequenceToTestAgainst = "",
    //pass this prop in!
    seqName = "Destination Vector",
    createYourOwnEnzyme,
    dispatch,
    hideModal,
    editorName
  } = props;
  createYourOwnEnzyme.chop_top_index = Number(
    createYourOwnEnzyme.chop_top_index
  );
  createYourOwnEnzyme.chop_bottom_index = Number(
    createYourOwnEnzyme.chop_bottom_index
  );
  const {
    sequence = "",
    chop_top_index = 0,
    chop_bottom_index = 0,
    name = ""
  } = createYourOwnEnzyme;
  const regexString = bpsToRegexString(sequence);
  const enzyme = {
    name,
    site: sequence,
    forwardRegex: regexString,
    reverseRegex: getReverseComplementSequenceString(regexString),
    topSnipOffset: chop_top_index,
    bottomSnipOffset: chop_bottom_index,
    usForward: 0,
    usReverse: 0,
    color: "black"
  };
  let invalid;
  if (!enzyme.name || !enzyme.site || !enzyme.forwardRegex || !enzyme.reverseRegex || !enzyme.topSnipOffset && enzyme.topSnipOffset !== 0 || !enzyme.bottomSnipOffset && enzyme.bottomSnipOffset !== 0) {
    invalid = true;
  }
  let matches;
  if (regexString.length === 0) {
    matches = [];
  } else {
    matches = cutSequenceByRestrictionEnzyme(
      inputSequenceToTestAgainst,
      true,
      enzyme
    );
  }
  const errors = validate(createYourOwnEnzyme);
  if (Object.keys(errors || {}).length) {
    invalid = true;
  }
  function onChange(updatedVal) {
    dispatch({
      type: "CREATE_YOUR_OWN_ENZYME_UPDATE",
      payload: {
        ...createYourOwnEnzyme,
        ...updatedVal
      }
    });
  }
  return /* @__PURE__ */ jsxs("div", { className: "createYourOwnEnzyme", children: [
    /* @__PURE__ */ jsx(Callout, { intent: "primary", children: 'This enzyme will be added to the "My Enzymes" group' }),
    /* @__PURE__ */ jsx(
      CustomInput,
      {
        error: errors["name"],
        value: name,
        onChange,
        name: "name",
        label: "Name:"
      }
    ),
    /* @__PURE__ */ jsx(
      CustomInput,
      {
        error: errors["sequence"],
        value: sequence,
        onChange,
        name: "sequence",
        label: /* @__PURE__ */ jsxs("div", { className: "labelWithIcon", children: [
          /* @__PURE__ */ jsx(InfoHelper, { children: /* @__PURE__ */ jsxs("div", { className: "taLineHolder", children: [
            /* @__PURE__ */ jsx(Line, { children: " Special Characters: " }),
            /* @__PURE__ */ jsx(Line, { children: " R = G A (purine) " }),
            /* @__PURE__ */ jsx(Line, { children: " Y = T C (pyrimidine) " }),
            /* @__PURE__ */ jsx(Line, { children: " K = G T (keto) " }),
            /* @__PURE__ */ jsx(Line, { children: " M = A C (amino) " }),
            /* @__PURE__ */ jsx(Line, { children: " S = G C (strong bonds) " }),
            /* @__PURE__ */ jsx(Line, { children: " W = A T (weak bonds) " }),
            /* @__PURE__ */ jsx(Line, { children: " B = G T C (all but A) " }),
            /* @__PURE__ */ jsx(Line, { children: " D = G A T (all but C) " }),
            /* @__PURE__ */ jsx(Line, { children: " H = A C T (all but G) " }),
            /* @__PURE__ */ jsx(Line, { children: " V = G C A (all but T) " }),
            /* @__PURE__ */ jsx(Line, { children: " N = A G C T (any) " })
          ] }) }),
          /* @__PURE__ */ jsx("span", { children: "Recognition sequence:" })
        ] }),
        onInput: function(input) {
          const inputValue = input.target.value;
          const cleanInput = inputValue.replace(/[^rykmswbdhvnagct]/gi, "");
          input.target.value = cleanInput;
        }
      }
    ),
    /* @__PURE__ */ jsx(
      CustomInput,
      {
        error: errors["chop_top_index"],
        value: chop_top_index,
        onChange,
        name: "chop_top_index",
        label: "Chop top index:",
        type: "number"
      }
    ),
    /* @__PURE__ */ jsx(
      CustomInput,
      {
        error: errors["chop_bottom_index"],
        value: chop_bottom_index,
        onChange,
        name: "chop_bottom_index",
        label: "Chop bottom index:",
        type: "number"
      }
    ),
    /* @__PURE__ */ jsx(
      EnzymeViewer,
      {
        ...{
          forwardSnipPosition: chop_top_index,
          paddingEnd,
          paddingStart,
          reverseSnipPosition: chop_bottom_index,
          sequence
        }
      }
    ),
    /* @__PURE__ */ jsx("br", {}),
    /* @__PURE__ */ jsx("h3", { className: "cutnumber " + (matches.length === 0 && "invalid"), children: matches.length > 10 ? `Cuts more than 10 times in ${seqName}` : `Cuts ${matches.length} time${matches.length === 1 ? "" : "s"} in ${seqName}` }),
    /* @__PURE__ */ jsx(
      DialogFooter,
      {
        hideModal,
        disabled: invalid,
        onClick: () => {
          addCustomEnzyme(enzyme);
          dispatch({
            type: "FILTERED_RESTRICTION_ENZYMES_ADD",
            //filteredRestrictionEnzymesAdd
            payload: {
              value: name
            },
            meta: {
              editorName
            }
          });
          hideModal && hideModal();
        }
      }
    )
  ] });
};
export default compose(
  wrapDialog({
    title: "Create Custom Enzyme"
  }),
  connectToEditor(({ sequenceData = {} }) => {
    return {
      seqName: sequenceData.name,
      inputSequenceToTestAgainst: sequenceData.sequence || ""
    };
  }),
  connect(function(state) {
    return {
      createYourOwnEnzyme: state.VectorEditor.__allEditorsOptions.createYourOwnEnzyme
    };
  })
)(CreateCustomEnzyme);
function validate(values) {
  const errors = {};
  if (!values.name || values.name.trim() === "") {
    errors.name = "Input cannot be blank";
  } else if (defaultEnzymesByName[values.name.toLowerCase()]) {
    errors.name = `The name ${values.name} is already taken.`;
  }
  if (!values.sequence || values.sequence.trim() === "" || values.sequence.trim().length < 4) {
    errors.sequence = "Enzyme recognition sequence must be at least 4bps long";
  }
  if (values.sequence && values.sequence.replace(/[^atgcrykmswbdhvn]/gi, "").length !== values.sequence.length) {
    errors.sequence = "Sequence must only contain valid bases";
  }
  if (!values.chop_top_index && values.chop_top_index !== 0) {
    errors.chop_top_index = "Input cannot be blank";
  }
  if (!values.chop_bottom_index && values.chop_bottom_index !== 0) {
    errors.chop_bottom_index = "Input cannot be blank";
  }
  return errors;
}
function bpsToRegexString(bps) {
  let regexString = "";
  if (typeof bps === "string") {
    bps.split("").forEach(function(bp) {
      if (bp === "r") {
        regexString += "[ga]";
      } else if (bp === "y") {
        regexString += "[tc]";
      } else if (bp === "k") {
        regexString += "[gt]";
      } else if (bp === "m") {
        regexString += "[ac]";
      } else if (bp === "s") {
        regexString += "[gc]";
      } else if (bp === "w") {
        regexString += "[at]";
      } else if (bp === "b") {
        regexString += "[gtc]";
      } else if (bp === "d") {
        regexString += "[gat]";
      } else if (bp === "h") {
        regexString += "[act]";
      } else if (bp === "v") {
        regexString += "[gca]";
      } else if (bp === "n") {
        regexString += "[agct]";
      } else {
        regexString += bp;
      }
    });
  }
  return regexString;
}
function CustomInput({ name, value, onChange, onInput, label, error, type }) {
  return /* @__PURE__ */ jsxs("div", { className: "inputHolder " + (error && "error"), children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("span", { children: label }),
      /* @__PURE__ */ jsx(
        "input",
        {
          value,
          onChange: function(e) {
            onChange({
              [name]: e.target.value
            });
          },
          onInput,
          type
        }
      )
    ] }),
    error && /* @__PURE__ */ jsx("p", { className: "errorMessage", children: error })
  ] });
}
function Line({ children }) {
  return /* @__PURE__ */ jsxs("div", { className: "taLine", children: [
    " ",
    children
  ] });
}
